import { render, staticRenderFns } from "./draftCompose.vue?vue&type=template&id=4ee5a1b4&"
import script from "./draftCompose.vue?vue&type=script&lang=js&"
export * from "./draftCompose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports